import {
    Button,
    DialogContent,
    Typography,
    Link,
    IconButton,
    Radio,
    RadioGroup,
    FormControlLabel,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { PrintOutlined } from '@material-ui/icons';
import React from 'react';
import * as Api from './api';
import Assinante from './Assinante';
import Cartelas from './Cartelas';
import Confirmacao from './ConfirmacaoRetirada';
import SucessoRetirada from './SucessoRetirada';
import useDialog from './useDialog';
import Selos from './Selos';
import ConfirmacaoPdf from './ConfirmacaoPdf';
import { BlobProvider } from '@react-pdf/renderer';
import { getUserProfile } from '../keycloak';

const styles = {
    root: {
        flex: 1,
        display: 'flex',
        minHeight: '90vh',
        justifyContent: 'space-around',
        flexDirection: 'column',
    },
};

const useColoredButton = makeStyles({
    disabled: { '&&': { backgroundColor: '#DCDCDC' } },
    root: {
        '&&': {
            color: 'black',
            backgroundColor: '#F8E332',
            '&:hover': { backgroundColor: '#F5D52B' },
        },
    },
});

const Retirada = ({
    assinante: {
        perfil,
        cartelas,
        selos,
        compartilhadoComigo,
        ...restAssinante
    },
    onFinalizar,
    promocaoPedido: {
        titulo,
        pedido,
        vigenciaInicio,
        vigenciaFim,
        dataInicioAgendamento,
        dataFimAgendamento,
    },
}) => {
    const [DialogConfirmacao, openConfirmacao, closeConfirmacao] = useDialog();
    const [DialogSucessoRetirada, openSucessoRetirada, closeSucessoRetirada] =
        useDialog();
    const [cartelasSelecionadas, setCartelasSelecionadas] = React.useState([]);
    const [
        cartelasCompartilhadasSelecionadas,
        setCartelasCompartilhadasSelecionadas,
    ] = React.useState([]);
    const [selosSelecionados, setSelosSelecionados] = React.useState([]);
    const [cartelasRetiradas, setCartelasRetiradas] = React.useState([]);
    const [selosRetirados, setSelosRetirados] = React.useState([]);

    const [urlPdf, setUrlPdf] = React.useState('#');

    const [status, setStatus] = React.useState(0);

    const currentUser = () => getUserProfile();

    const [produtos, setProdutos] = React.useState([]);

    const handleGetPromocao = async () => {
        await Api.getPromocaoUsuario(perfil.cpf)
            .then((response) => {
                setProdutos(response);
            })
            .then(() => {
                setCartelasRetiradas(
                    cartelas ? cartelas.filter((e) => e.dataRetirada) : [],
                );
                setSelosRetirados(
                    selos ? selos.filter((e) => e.dataRetirada) : [],
                );
            })
            .finally(() => {
                setUrlPdf();
            });
    };

    React.useEffect(() => {
        handleGetPromocao();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cartelas, selos]);

    const totalCartelas = cartelasSelecionadas.reduce(
        (total, { quantidade }) => total + quantidade,
        0,
    );
    const totalCartelasCompartilhadas =
        cartelasCompartilhadasSelecionadas.reduce(
            (total, { quantidade }) => total + quantidade,
            0,
        );
    const totalSelos = selosSelecionados.reduce(
        (total, { quantidade, listaPrecoItemDerivacaoProdutoQuantidade }) =>
            total + quantidade * listaPrecoItemDerivacaoProdutoQuantidade,
        0,
    );

    const finalizar = () => {
        closeSucessoRetirada();
        onFinalizar();
        window.location.reload();
    };

    const confirmarRetirada = () => {
        const retiradoPor = currentUser().name || currentUser().email || '';

        const items = [
            ...cartelasSelecionadas,
            ...selosSelecionados,
            ...cartelasCompartilhadasSelecionadas,
        ];

        const payload = items.map((cartela) => ({
            ...cartela,
            retiradoPor,
        }));

        Api.confirmarRetirada(payload)
            .then(() => {
                setSelosRetirados(selosSelecionados);
                setCartelasRetiradas(cartelasSelecionadas);
            })
            .then(closeConfirmacao)
            .then(openSucessoRetirada);
    };

    const radioHandler = (status) => {
        setStatus(status);
    };

    const Impressao = (
        <ConfirmacaoPdf
            assinante={perfil}
            compartilhadoComigo={compartilhadoComigo}
            cartelas={cartelasRetiradas}
            selos={selosRetirados}
            usuario={currentUser()}
        />
    );

    const classes = useColoredButton();

    const isDisabledRetiradaBtn =
        totalCartelas === 0 &&
        totalSelos === 0 &&
        totalCartelasCompartilhadas === 0;

    return (
        <>
            <div style={styles.root}>
                <Assinante value={perfil} />
                <RadioGroup row defaultValue="a">
                    <FormControlLabel
                        value="a"
                        control={<Radio />}
                        label="Todos os Kits"
                        checked={status === 0}
                        onClick={(e) => radioHandler(0)}
                    />
                    <FormControlLabel
                        value="b"
                        control={<Radio />}
                        label="Kits Disponíveis para Retirada"
                        checked={status === 2}
                        onClick={(e) => radioHandler(2)}
                    />
                </RadioGroup>
                <Typography variant="h5">Cartelas</Typography>
                <Cartelas
                    value={cartelas}
                    onSelecionar={setCartelasSelecionadas}
                    usuario={currentUser()}
                    btnRadio={status}
                    produtos={produtos}
                    perfilCompartilhado=""
                    cartela="principal"
                />
                {Object.keys(compartilhadoComigo).length !== 0 && (
                    <>
                        <Typography variant="h5">
                            Cartelas Compartilhadas
                        </Typography>
                        {compartilhadoComigo.map((compartilhadoPor, index) => (
                            <React.Fragment key={compartilhadoPor.perfil?.cpf || index}>
                                <Cartelas
                                    value={compartilhadoPor.cartelas}
                                    usuario={currentUser()}
                                    onSelecionar={
                                        setCartelasCompartilhadasSelecionadas
                                    }
                                    btnRadio={status}
                                    perfil={perfil}
                                    produtos={produtos}
                                    perfilCompartilhado={
                                        compartilhadoPor.perfil
                                    }
                                    cartela="compartilhada"
                                />
                            </React.Fragment>
                        ))}
                    </>
                )}
                <Typography variant="h5">Selos</Typography>
                <Selos
                    value={selos}
                    usuario={currentUser()}
                    onSelecionar={setSelosSelecionados}
                    btnRadio={status}
                    perfil={perfil}
                    produtos={produtos}
                />
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: '10px',
                        marginBottom: '35px',
                    }}
                >
                    <Button color="default" onClick={finalizar}>
                        VOLTAR
                    </Button>
                    <Button
                        style={{ minWidth: '250px' }}
                        className={
                            isDisabledRetiradaBtn
                                ? classes.disabled
                                : classes.root
                        }
                        onClick={openConfirmacao}
                        disabled={isDisabledRetiradaBtn}
                    >
                        RETIRAR
                    </Button>
                    <Link
                        component={IconButton}
                        href={urlPdf}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <PrintOutlined />
                    </Link>
                </div>
                <div>
                    {!urlPdf && (
                        <BlobProvider document={Impressao}>
                            {({ blob, url, loading, error }) => {
                                if (url) setTimeout(() => setUrlPdf(url), 500);
                                return loading ? (
                                    <div>Carregando impressão ...</div>
                                ) : null;
                            }}
                        </BlobProvider>
                    )}
                </div>
            </div>
            <DialogConfirmacao maxWidth={false}>
                <DialogContent>
                    <Confirmacao
                        assinante={perfil}
                        cartelas={[
                            ...cartelasSelecionadas,
                            ...cartelasCompartilhadasSelecionadas,
                        ]}
                        selos={selosSelecionados}
                        onConfirmar={confirmarRetirada}
                    />
                </DialogContent>
            </DialogConfirmacao>
            <DialogSucessoRetirada maxWidth={false} onClose={finalizar}>
                <DialogContent>
                    <SucessoRetirada
                        totalCartelas={totalCartelas}
                        totalSelos={totalSelos}
                        impressao={Impressao}
                        onClick={finalizar}
                    />
                </DialogContent>
            </DialogSucessoRetirada>
        </>
    );
};

Retirada.defaultProps = {
    assinante: {},
    onFinalizar: console.warn,
    promocaoPedido: {},
};

export default Retirada;
